import { Component, inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApiActivity } from '../../core/http/api-activity';

/**
 * While the page loads data, a thin bar runs across the top. While a change is being saved (submit, approve,
 * delete...), the page is dimmed behind a centred spinner, so the user sees it is working and cannot click again.
 */
@Component({
  selector: 'app-api-busy',
  imports: [MatProgressBarModule, MatProgressSpinnerModule],
  template: `
    @if (activity.busy() && !activity.saving()) {
      <mat-progress-bar class="api-busy" mode="indeterminate" aria-label="Loading" />
    }
    @if (activity.saving()) {
      <div class="api-saving" role="status" aria-live="polite">
        <mat-spinner diameter="48" aria-label="Saving" />
      </div>
    }
  `,
  styles: `
    .api-busy {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2000;
      height: 3px;
    }

    .api-saving {
      position: fixed;
      inset: 0;
      z-index: 2001;
      display: grid;
      place-items: center;
      background: rgba(255, 255, 255, 0.55);
      cursor: progress;
    }
  `,
})
export class ApiBusyComponent {
  readonly activity = inject(ApiActivity);
}
